customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    const templateNode = document.getElementById('recently-viewed-products-template');
    if (!templateNode || !templateNode.content || !templateNode.content.firstElementChild) {
      return;
    }

    this.template = templateNode.content.firstElementChild.cloneNode(true);
    this.track = this.template.querySelector('.gridy-track');
    if (!this.track) {
      return;
    }
    this.track.innerHTML = '';
    this.slider = this.template.querySelector('gridy-slider');
    this.sliderArrows = this.template.querySelector('.gridy-arrows');
    this.data_ipr_desktop = parseInt(this.slider?.dataset.iprDesktop, 10) || 1;
    this.data_ipr_tablet = parseInt(this.slider?.dataset.iprTablet, 10) || this.data_ipr_desktop;
    this.data_ipr_mobile = parseInt(this.slider?.dataset.iprMobile, 10) || 1;

    this.limit = parseInt(this.dataset.limit, 10) || 10;
    this.currentTemplate = this.dataset.currentTemplate;
    this.showAsThumbnails = this.dataset.showAsThumbnails != undefined ? JSON.parse(this.dataset.showAsThumbnails) : false;

    // Section remains hidden if no history data found
    // History data is set from product-template.liquid
    this.history = this.loadHistory();

    if (!this.history.length) {
      return;
    }

    this.fetchProductHtml();
  }

  normalizeHandle(value) {
    try {
      return decodeURIComponent((value || '').trim()).toLowerCase();
    } catch (err) {
      return (value || '').trim().toLowerCase();
    }
  }

  getCurrentHandle() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const productsIndex = parts.lastIndexOf('products');
    if (productsIndex === -1 || !parts[productsIndex + 1]) {
      return '';
    }
    return this.normalizeHandle(parts[productsIndex + 1]);
  }

  loadHistory() {
    const storageKey = 'Woolman_Product_History';
    const storedHistory = sessionStorage.getItem(storageKey) ? sessionStorage.getItem(storageKey).split(',') : [];
    const seenHandles = new Set();
    const uniqueHistory = [];

    for (const rawHandle of storedHistory) {
      const handle = this.normalizeHandle(rawHandle);
      if (!handle || seenHandles.has(handle)) {
        continue;
      }
      seenHandles.add(handle);
      uniqueHistory.push(handle);
    }

    if (this.currentTemplate === 'template-product') {
      const currentHandle = this.getCurrentHandle();
      const visibleHistory = [];
      let currentRemoved = false;

      for (const handle of uniqueHistory) {
        if (!currentRemoved && currentHandle && handle === currentHandle) {
          currentRemoved = true;
          continue;
        }
        visibleHistory.push(handle);
      }

      const normalizedStorageHistory = currentHandle ? [currentHandle, ...visibleHistory] : visibleHistory;
      sessionStorage.setItem(storageKey, normalizedStorageHistory.slice(0, 10).join(','));
      return visibleHistory;
    }

    sessionStorage.setItem(storageKey, uniqueHistory.slice(0, 10).join(','));
    return uniqueHistory;
  }

  getCardPathKey(cardNode) {
    if (!cardNode || !cardNode.querySelector) {
      return '';
    }
    const cardLink = cardNode.querySelector('.card-media[href], .card-title a[href]');
    if (!cardLink) {
      return '';
    }
    try {
      const parsedUrl = new URL(cardLink.getAttribute('href') || '', window.location.href);
      const pathname = (parsedUrl.pathname || '').replace(/\/+$/, '');
      return pathname || '/';
    } catch (err) {
      return '';
    }
  }

  /* This function fetches item HTML snippets and passes them to initContainer function */
  async fetchProductHtml() {
    const historyItems = this.history.slice(0, this.limit);
    if (!historyItems.length) {
      return;
    }
    const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    const cardView = this.showAsThumbnails ? 'ajax-card-recommendation-thumbnail' : 'ajax-card-recommendation';
    const div = document.createElement("div");
    for (var i = 0; i < historyItems.length; i++) {
      div.setAttribute('data-index', i);
      this.track.appendChild(div.cloneNode(true));
    }

    const settledPromises = await Promise.allSettled(
      historyItems.map((productHandle) => fetch(`${rootUrl}products/${productHandle}?view=${cardView}`))
    );
    const renderedCardPaths = new Set();
    for (let index = 0; index < settledPromises.length; index++) {
      const promise = settledPromises[index];
      try {
        if (promise.status !== 'fulfilled') {
          continue;
        }
        const res = promise.value;
        if (res.status !== 200) {
          throw res.status;
        }
        const htmlString = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const nextCard = doc.body.firstElementChild;
        if (!nextCard) {
          continue;
        }
        const cardPathKey = this.getCardPathKey(nextCard);
        if (cardPathKey && renderedCardPaths.has(cardPathKey)) {
          const duplicateSlot = this.track.querySelector(`[data-index="${ index }"]`);
          if (duplicateSlot && duplicateSlot.parentNode) {
            duplicateSlot.parentNode.removeChild(duplicateSlot);
          }
          continue;
        }
        if (cardPathKey) {
          renderedCardPaths.add(cardPathKey);
        }
        const childToReplace = this.template.querySelector(`[data-index="${ index }"]`);
        if (!childToReplace || !childToReplace.parentNode) {
          continue;
        }
        const parent = childToReplace.parentNode;
        parent.replaceChild(nextCard, childToReplace);
      } catch (err) {
        console.error(err);
        // You might want to handle errors within the forEach here
      }
    }

    this.track.querySelectorAll('[data-index]').forEach((node) => node.remove());
    const renderedCardsCount = this.track.querySelectorAll('.card.card--product').length;
    if (!renderedCardsCount) {
      return;
    }

    if (this.sliderArrows && this.data_ipr_mobile >= renderedCardsCount) {
      this.sliderArrows.classList.add('sm-down-hide');
    }
    if (this.sliderArrows && this.data_ipr_tablet >= renderedCardsCount) {
      this.sliderArrows.classList.add('sm-to-md-hide');
    }
    if (this.sliderArrows && this.data_ipr_desktop >= renderedCardsCount) {
      this.sliderArrows.classList.add('md-hide');
    }
    this.appendChild(this.template);
    this.removeAttribute('hidden');
    document.dispatchEvent(new CustomEvent('product-grid:updated'));
  }
})
